import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconOrders from 'components/icons/IconOrders';

const styles = () => ({
  root: {
    minHeight: 530,
  },
  iconOrders: {
    width: 108,
    height: 124,
  },
  typography: {
    width: 290,
  },
});

const ProductClaimEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconOrders className={classes.iconOrders} />
    </Grid>
    <Grid item>
      <Typography
        className={classes.typography}
        variant="subheading"
        color="secondary"
        align="center"
      >
        Search products you need to create order on
      </Typography>
    </Grid>
  </Grid>
);

ProductClaimEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconOrders: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ProductClaimEmpty);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimEmpty.js